import React, {useState} from 'react';
import {
    Button,
    Card,
    CardBody,
    CardFooter,
    CardTitle,
    Container,
    Row,
    Col,
} from "reactstrap";
import LandingPageHeader from "../components/Headers/LandingPageHeader";
import ExamplesNavbar from "../components/Navbars/ExamplesNavbar";
import DemoFooter from "../components/Footers/DemoFooter";
import {scroller} from "react-scroll";
import * as emailjs from "@emailjs/browser";
import {useNavigate} from "react-router-dom";
import Swal from "sweetalert2";
import {articles, articlesForHome} from "../data/articles/articles";
import img from "../assets/images/nuno-marques.jpg";


function Home(props) {

    const navigate = useNavigate();


    const handleScrollProducts = () => {
        scroller.scrollTo('products-section', {
            duration: 300,
            delay: 0,
            smooth: 'easeInOutQuart',
            offset: -80
        });
    };

    const handleScrollContact = () => {
        scroller.scrollTo('contact-section', {
            duration: 300,
            delay: 0,
            smooth: 'easeInOutQuart',
            offset: -80
        });
    };

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });

    const handleChange = (e) => {
        const {id, value} = e.target;
        setFormData(prev => ({
            ...prev,
            [id]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Gönderilen veriler:', formData);
        // Burada API gönderimi veya başka bir işlem yapılabilir
        emailjs.send(
            'service_9joqq4p',
            'template_qeiw0rw',
            formData,
            'wxzzqAYhW4k_VTJww'
        )
            .then(
                (result) => {
                    console.log(result.text);
                    Swal.fire({
                        title: 'En Kısa Sürede Sizinle İletişime Geçeceğiz',
                        icon: 'success',
                        confirmButtonColor: '#25053b'
                    })
                    setFormData({
                        name: '',
                        email: '',
                        phone: '',
                        message: ''
                    }); // Formu sıfırla

                },
                (error) => {
                    console.log(error.text);
                    alert("Gönderim hatası.");
                }
            );
    };

    return (
        <>
            <LandingPageHeader handleScrollProducts={handleScrollProducts} handleScrollContact={handleScrollContact}/>

            <img className="info-image" src={img}/>

            <div className="blog-card">
                <div className="row">

                    {articlesForHome.map((article, index) => (
                        <a className="example-2 card-blog" style={{cursor: "pointer"}} href={article.link}>
                            <div
                                key={index}
                                className="wrapper"
                                style={{
                                    background: `url(${article.image}) center / cover no-repeat`
                                }}
                            >
                                <div className="data">
                                    <div className="content" style={{color: article.color}}>
                                        <h1 className="title" style={{color: article.color}}><a href={article.link}>{article.title}</a>
                                        </h1>
                                        <p className="text">{article.content}</p>
                                        <a href={article.link} className="button">Devamını oku</a>
                                    </div>
                                </div>
                            </div>

                        </a>
                    ))}


                </div>


            </div>


            <div className="main" name="products-section" id="products-section">
                <div className="section text-center">
                    <Container>
                        <h2 className="title">Ürünler</h2>
                        <h5 className="description">
                            Ürünlerimiz hakkında daha fazla bilgi almak veya ihtiyaçlarınıza özel bir çözüm
                            oluşturmak için bizimle iletişime geçebilirsiniz.
                            Ekibimiz, size en uygun solar enerji sistemini sunmak için hazır. Detaylar ve teklif
                            talepleri için hemen ulaşın.
                        </h5>
                        <br/>
                        <Button
                            className="btn-round"
                            color="info"
                            onClick={(e) => handleScrollContact()}
                        >
                            İletişim
                        </Button>
                        <br/>
                        <br/>
                        <div className="products-container" style={{background: "#ace"}}>
                            <div className="gridywrap">
                                <div className="gridy-2 gridyhe-1">
                                    <div className="gridimg"
                                         style={{backgroundImage: 'url(https://c0.wallpaperflare.com/preview/983/26/531/array-solar-panel-electricity.jpg)'}}>&nbsp;</div>

                                    <div className="gridinfo">
                                        <h3>Solar Paneller</h3>
                                        <div className="gridmeta">

                                            <p className="gridwho"> Tommaho</p>
                                            <p className="gridwho"> Tommaho</p>
                                            <p className="gridwho"> Tommaho</p>
                                        </div>
                                        <p className="gridexerpt">Solar panellerimiz hakkında detaylı bilgi için
                                            tıklayın</p>
                                        <a onClick={() => navigate('/products', {
                                            state: {
                                                type: 'solar',
                                            }
                                        })
                                        } className="grid-btn"><span>Solar Panelleri Gör</span> <i
                                            className="fa fa-plus"></i></a>
                                    </div>
                                </div>
                                <div className="gridy-1 gridyhe-1">
                                    <div className="gridimg"
                                         style={{backgroundImage: 'url(https://images.unsplash.com/photo-1662601699213-cb84f13d86df?q=80&w=3270&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D)'}}>&nbsp;</div>

                                    <div className="gridinfo">
                                        <h3>İnverterler</h3>
                                        {/*<div className="gridmeta">
                                            <p className="gridwhen"><i className="fa fa-clock-o"></i> 17:22 17th Feb
                                                2015</p>
                                            <p className="gridwho"><i className="fa fa-user"></i> Harvey Dent</p>
                                        </div>*/}
                                        <p className="gridexerpt">İnvertleri görmek için tıklayın</p>
                                        <a onClick={() => navigate('/products', {
                                            state: {
                                                type: 'inverter',
                                            }
                                        })
                                        } className="grid-btn grid-more"><span>İnverterleri Gör</span> <i
                                            className="fa fa-plus"></i></a>
                                    </div>
                                </div>
                                <div className="gridy-1 gridyhe-2">
                                    <div className="gridimg"
                                         style={{backgroundImage: 'url(https://images.unsplash.com/photo-1602918386084-58983c3bafac?q=80&w=3164&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D)'}}>&nbsp;</div>

                                    <div className="gridinfo">
                                        <h3>Araç Şarj İstasyonları</h3>
                                        <p className="gridexerpt">Araj Şarj İstasyonlarını görmek için tıklayın</p>
                                        <a onClick={() => navigate('/products', {
                                            state: {
                                                type: 'aracSarj',
                                            }
                                        })
                                        } className="grid-btn grid-more"><span>Araj Şarj İstasyonlarını Görün</span> <i
                                            className="fa fa-plus"></i></a>
                                    </div>
                                </div>
                                <div className="gridy-2 gridyhe-1">
                                    <div className="gridimg"
                                         style={{backgroundImage: 'url(https://images.unsplash.com/photo-1592318348310-f31b61a931c8?q=80&w=3270&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D)'}}>&nbsp;</div>

                                    <div className="gridinfo">
                                        <h3>Enerji Depolama Sistemleri</h3>
                                        <p className="gridexerpt">Enreji Depolama ürünlerimiz hakkında detaylı bilgi
                                            için tıklayın</p>
                                        <a onClick={() => navigate('/products', {
                                            state: {
                                                type: 'enerjiDepolama',
                                            }
                                        })
                                        } className="grid-btn grid-more"><span>Enerji Depolama Ürünleri</span> <i
                                            className="fa fa-plus"></i></a>
                                    </div>
                                </div>
                                <div className="gridy-1 gridyhe-1">
                                    <div className="gridimg"
                                         style={{backgroundImage: 'url(https://tommatech.de/images/product/459_tommatech-60a-1224v-2usb-pwm-sarj-kontrol-cihazi_0.jpg)'}}>&nbsp;</div>
                                    <div className="gridinfo">
                                        <h3>Şarj Kontrol Cihazları</h3>

                                        <p className="gridexerpt">Şarj Kontrol Cihazlarını hakkında detaylı bilgi için
                                            tıklayın</p>
                                        <a onClick={() => navigate('/products', {
                                            state: {
                                                type: 'sarjKontrol',
                                            }
                                        })
                                        } className="grid-btn grid-more"><span>Şarj Kontrol Cihazları</span> <i
                                            className="fa fa-plus"></i></a>
                                    </div>
                                </div>
                                <div className="gridy-1 gridyhe-1">
                                    <div className="gridimg"
                                         style={{backgroundImage: 'url(https://images.unsplash.com/photo-1697665896499-1fa6b9ddbac0?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NDB8fHNvbGFyJTIwZXF1aXBtZW50c3xlbnwwfHwwfHx8MA%3D%3D)'}}>&nbsp;</div>

                                    <div className="gridinfo">
                                        <h3>Solar Ekipmanlar</h3>

                                        <p className="gridexerpt">Her türlü ihtiyaca yönelik solar ekipmanları
                                            inceleyin</p>
                                        <a onClick={() => navigate('/products', {
                                            state: {
                                                type: 'solarEkipman',
                                            }
                                        })
                                        } className="grid-btn grid-more"><span>Solar Ekipmanları Gör</span> <i
                                            className="fa fa-plus"></i></a>
                                    </div>
                                </div>
                                <div className="gridy-2 gridyhe-1">
                                    <div className="gridimg"
                                         style={{backgroundImage: 'url(https://images.unsplash.com/photo-1660330589243-4c640d878052?q=80&w=3132&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D)'}}>&nbsp;</div>

                                    <div className="gridinfo">
                                        <h3>Solar Paketler</h3>

                                        <p className="gridexerpt">İhtiyacınıza yönelik solar paketleri inceleyin</p>
                                        <a onClick={() => navigate('/products', {
                                            state: {
                                                type: 'solarPaket',
                                            }
                                        })
                                        } className="grid-btn grid-more"><span>Solar Paketleri Gör</span> <i
                                            className="fa fa-plus"></i></a>
                                    </div>
                                </div>
                                <div className="gridy-1 gridyhe-1">
                                    <div className="gridimg"
                                         style={{backgroundImage: 'url(https://images.unsplash.com/photo-1698479603408-1a66a6d9e80f?q=80&w=2955&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D)'}}>&nbsp;</div>

                                    <div className="gridinfo">
                                        <h3>Isıtma - Soğutma</h3>

                                        <p className="gridexerpt">Her türlü ihtiyaca yönelik ısıtma - soğutma
                                            ekipmanlarını inceleyin</p>
                                        <a onClick={() => navigate('/products', {
                                            state: {
                                                type: 'isitma',
                                            }
                                        })
                                        } className="grid-btn grid-more"><span>Isıtma - Soğutma Cihazlarını Gör</span>
                                            <i
                                                className="fa fa-plus"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{height: 10}}></div>
                        <Row className="justify-content-center gap-5 mb-5">

                        </Row>
                    </Container>
                </div>


                <div style={{backgroundColor: ''}} className="section section-dark  text-center" name="contact-section"
                     id="contact-section">
                    <Container>

                        <Row className="justify-content-center">
                            <Col md={"6"}>
                                <section className="get-in-touch">
                                    <h1 className="title">Adres</h1>
                                </section>
                                <iframe
                                    className="w-75 h-50"
                                    title="Ozsolar enerji çorum konum"
                                    src="https://www.google.com/maps/embed/v1/place?q=özsolar+enerji+çorum&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8">
                                    allowFullScreen={true}
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    >
                                </iframe>

                            </Col>
                            <Col>
                                <section className="get-in-touch">
                                    <h1 className="title">Mesajınızı İletin</h1>
                                    <form className="contact-form row" onSubmit={handleSubmit}>
                                        <div className="form-field col-lg-6">
                                            <input
                                                id="name"
                                                className={`input-text ${formData.name ? 'not-empty' : ''} js-input`}
                                                type="text"
                                                required
                                                value={formData.name}
                                                onChange={handleChange}
                                            />
                                            <label className="label" htmlFor="name">Adınız</label>
                                        </div>

                                        {/*<div className="form-field col-lg-6">
                                            <input
                                                id="email"
                                                className="input-text js-input"
                                                type="email"
                                                required
                                                value={formData.email}
                                                onChange={handleChange}
                                            />
                                            <label className="label" htmlFor="email">E-mail</label>
                                        </div>*/}

                                        <div className="form-field col-lg-6">
                                            <input
                                                id="phone"
                                                className={`input-text ${formData.phone ? 'not-empty' : ''} js-input`}
                                                type="text"
                                                required
                                                value={formData.phone}
                                                onChange={handleChange}
                                            />
                                            <label className="label" htmlFor="phone">İletişim numarası</label>
                                        </div>

                                        <div className="form-field col-lg-12">
                                            <input
                                                id="message"
                                                className={`input-text ${formData.message ? 'not-empty' : ''} js-input`}
                                                type="text"
                                                required
                                                value={formData.message}
                                                onChange={handleChange}
                                            />
                                            <label className="label" htmlFor="message">Mesajınız</label>
                                        </div>

                                        <div className="form-field col-lg-12">
                                            <input className="submit-btn" type="submit" value="Gönder"/>
                                        </div>
                                    </form>
                                </section>
                            </Col>
                        </Row>
                    </Container>
                </div>

            </div>

        </>
    );
}

export default Home;
